import { Component, OnInit } from '@angular/core';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-have-existing-mortgage',
    templateUrl: '../../step/button-step/button-step.component.html',
    styleUrls: ['./have-existing-mortgage.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class HaveExistingMortgageComponent extends ButtonStepComponent implements OnInit {
  title: string = "Do you have an existing mortgage but are just looking for equity out of the house?";

  buttonList = [
    { text: 'Yes', value: 'yes', imageName: 'yes', goal: '72', default: true },
    { text: 'No', value: 'no', imageName: 'no-x', goal: '77' },
  ];

  initStep() {

  }

  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('hasExistingMortgage', this.control);
  }

  submit(button) {
    if(button?.goal) {
      this.analyticsService.trackGoal(button.goal);
    }
    super.submit(button);
  }
}
